/**
 * useFeatureTracking
 * Provides tracking functions for key user actions
 * Import and call these in components where features are used
 */

import { useCallback } from 'react';
import { eventService } from '@/services/tracking/eventService';

export function useFeatureTracking() {
  const trackWizardStep = useCallback((step: number, action: 'enter' | 'complete' | 'abandon') => {
    eventService.trackWizardStep(step, action);
  }, []);

  const trackAnalysis = useCallback((action: 'started' | 'completed' | 'abandoned', metadata?: Record<string, unknown>) => {
    eventService.trackAnalysis(action, metadata);
  }, []);

  const trackResultCard = useCallback((cardName: string, action: 'opened' | 'closed') => {
    eventService.trackResultCard(cardName, action);
  }, []);

  const trackShare = useCallback((action: 'created' | 'viewed') => {
    eventService.trackShare(action);
  }, []);

  const trackFeature = useCallback((action: string, label?: string, value?: number) => {
    eventService.trackFeature(action, label, value);
  }, []);

  return {
    trackWizardStep,
    trackAnalysis,
    trackResultCard,
    trackShare,
    trackFeature,
  };
}
